import store from '@/store/store'
import mergeWith from 'ramda/src/mergeWith'
import concat from 'ramda/src/concat'
import { ANSWER_END, INPUT_TYPES, STATE_ID } from '@/utils/bot-json.constants'
import { NODE_TYPES } from '@/utils/state-tree.generator'
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import conversationModule from '@/store/modules/conversation.module'

class AnswerModule {

  getAnswer = () => store.state.answer

  setAnswer(answer) {
    store.commit('ANSWER_SET', answer)
  }

  isAnswerUsagesShown = () => store.state.ui.preview.answerUsages.isShown

  getAnswerList = () => store.state.answerList

  setAnswerList(answerList) {
    store.commit('ANSWER_LIST_SET', answerList)
  }

  setAnswerVariantList(answerVariantList) {
    store.commit('ANSWER_VARIANT_LIST_SET', answerVariantList)
  }

  getAnswerVariantList = () => store.state.answerVariantList

  isAnswerEditor() {
    return this.getAnswer() !== null
  }

  isEmptyAnswer() {
    return this.isAnswerEditor() && chatBubbleModule.stateTree.get()?.type === NODE_TYPES.EMPTY
  }

  getAnswerEndType() {
    const firstTransition = conversationModule.getRootJson().states?.root?.transitions[0]
    if (firstTransition?.condition?.input === INPUT_TYPES.AI_JUDGE) return ANSWER_END.CONTINUE_OR_FIND_INTENT

    return firstTransition?.state === STATE_ID.REF_GLOBAL_FIND_INTENT ?
      ANSWER_END.FIND_INTENT :
      ANSWER_END.IDLE
  }

  setAnswerRefsCreates(creates) {
    store.commit('ANSWER_REFS_CREATES_SET', creates)
  }

  setAnswerRefsDeletes(deletes) {
    store.commit('ANSWER_REFS_DELETES_SET', deletes)
  }

  resetAnswerRefs() {
    this.setAnswerRefsCreates([])
    this.setAnswerRefsDeletes([])
  }

  answerRefs = () => store.state.answerRefs

  restoreAnswerRefs(archivedAnswerRefs) {
    const answerRefs = mergeWith(concat, archivedAnswerRefs, this.answerRefs())
    this.setAnswerRefsDeletes(answerRefs.deletes)
    this.setAnswerRefsCreates(answerRefs.creates)
  }

  showUsages() {
    store.commit('UI_ANSWER_USAGES_SET', true)
  }

  hideUsages() {
    store.commit('UI_ANSWER_USAGES_SET', false)
  }
}

export default new AnswerModule()
